import React from 'react';

const Footer = () => {
  return (
    <footer className="frame frame--footer">
      <span>
        Made by{' '}
        <a href="https://codrops.com/" className="line">
          @codrops
        </a>
      </span>
      <span>
        <a href="https://tympanus.net/codrops/demos/" className="line">
          All demos
        </a>
      </span>
    </footer>
  );
};

export default Footer;
